<template>
  <div class="wrapper">
    <div class="col-12 p-0 m-0">
      <div class="header">
        <h4 class="mb-0">
        {{ $t('aiReports.aiAnalysis') }}
        </h4>
      </div>
    </div>
    <div class="col-12 ai-card-line">
      <div class="col-4 ai-card">
        <div class="ai-card-image-container">
          <div class="ai-card-image">
          </div>
        </div>
        <div class="ai-card-text-container">
          <div class="ai-card-text-title">
            {{ $t('aiReports.swotAnalysis') }}
          </div>
          <div class="ai-card-text-body">
            {{ $t('aiReports.swotAnalysisText') }}
          </div>
        </div>
        <router-link class="ai-card-button" :to="`/aiswotreports`">
            <div class="ai-button-text">
            {{ $t('aiReports.selectReport') }}
            </div>
        </router-link>
      </div>
      <div class="ai-card-space">
      </div>
      <div class="col-4 ai-card">
        <div class="ai-card-image-container">
          <div class="ai-card-image">
          </div>
        </div>
        <div class="ai-card-text-container">
          <div class="ai-card-text-title">
            {{ $t('aiReports.summarization') }}
          </div>
          <div class="ai-card-text-body">
            {{ $t('aiReports.summarizationText') }}
          </div>
        </div>
        <router-link class="ai-card-button" :to="`/aisummarizationreports`">
            <div class="ai-button-text">
            {{ $t('aiReports.selectReport') }}
            </div>
        </router-link>
      </div>
      <div class="ai-card-space">
      </div>
      <div class="col-4 ai-card">
        <div class="ai-card-soon-container">
          <div class="ai-card-soon-text">
            {{ $t('aiReports.comingSoon') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import EventBus from '../../../../eventBus';

export default {
  components: {
  },
  computed: {
    ...mapState('authentication', ['userProfile']),
    ...mapFields('settings', ['country']),
    ...mapState('companies', ['myMetric', 'company']),
    ...mapState('actions', ['allActions', 'allGroups']),
    ...mapState('branches', ['myIh1','ih1']),
  },
  data() {
    return {
      selected: null,
      userAuth: null,
      options: [],
      viewType: null,
      reports: [],
    };
  },
  methods: {
  },
  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    if (!this.userProfile.permissions.reports.menu) {
      this.$router.push(`/dashboard/${this.userAuth.companyId}`);
    }
    EventBus.$on('iaReport', (reportSelect) => {
      let path = null;
      switch (reportSelect) {
        case 'Análise SWOT':
          path = '/aiswotreports';
          break;
        case 'Sumarização':
          path = '/aisummarizationreports';
          break;
      }
      if (path && this.$route.path !== path) this.$router.push(path).catch(err => {});
    });
  },

  async mounted() {
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  background-color: #fff;
  min-height: 100%;
  padding: 20px;
}

b-button {
  outline: none;
}

.btn:focus {
  outline: none;
  box-shadow: none;
}
.btn {
  box-shadow: none !important;
}
.ai-card-line {
  display: flex;
  margin-top: 20px;
  padding: 0;
}
.ai-card {
  display: flex;
  height: 370px;
  padding: 24px 12px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 8px;
  background: #FFF; 
  box-shadow: 2px 2px 6px 0px rgba(41, 70, 97, 0.20); 
}
.ai-card-image-container {
  display: flex;
  height: 110.125px;
  padding: 42px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 12px;
  background: rgba(232, 232, 232, 0.50); 
}
.ai-card-image {
  width: 88px;
  height: 88px;
  flex-shrink: 0; 
  background: url(../../../../assets/swot.png); 
}
.ai-card-text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch; 
}
.ai-card-text-title {
  color: #242424;
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: SF Pro Display;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.35px; 
}
.ai-card-text-body {
  align-self: stretch;
  color: #5E5E5E;
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: SF Pro Text;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 114.286% */
  letter-spacing: -0.24px;
}
.ai-card-button {
  display: flex;
  height: 38px;
  padding: 6px 16px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex: 1 0 0;
  border-radius: 4px;
  background: #3DB374;
  bottom: 24px;
  position: absolute;
  cursor: pointer;
}
.ai-button-text {
  color: #FFF;
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: SF Pro Text;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.408px; 
}
.ai-card-soon-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 4px;
  background: rgba(217, 217, 217, 0.50); 
}
.ai-card-soon-text {
  position: relative;
  top: 45%;
  color: #242424;
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: SF Pro Display;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 109.091% */ 
}
.ai-card-space {
  padding: 0px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/reports/ai-analysis/index.vue